module.exports = __webpack_public_path__ + "media/images/pages/img_digest_restaurant_01-1525789d267d73349c79b2dd82990a14.jpg";